import React from "react";

export default function SeaHuntingIcon(props) {
  return(
      <img src="/Icons/seaHunting.svg" alt="sea hunting" {...props}/>
  )
}
